import { Box, Typography } from '@mui/material';
import { Gauge } from '@mui/x-charts';
import { useLanguage } from '../../../utils/i18n';

export default function SpeedGauge({ value = 0 }) {
  const { t } = useLanguage();
  return (
    <Box sx={{ border: 1, borderRadius: 1, p: 1, borderColor: '#e1e1e1', textAlign: 'center', minWidth: 60 }}>
      <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#1a237e', fontSize: 12 }}>
        {t('mapsTracking.speed', 'Speed')}
      </Typography>
      <Box sx={{ width: 60, height: 60, mx: 'auto', position: 'relative' }}>
        <Gauge
          sx={{ fontSize: 11 }}
          value={Math.round(value)}
          valueMax={160}
          startAngle={-110}
          endAngle={110}
          innerRadius="70%"
          outerRadius="100%"
        />
      </Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', px: 0.5, mt: 1 }}>
        <Typography sx={{ fontSize: 10 }}>0</Typography>
        <Typography sx={{ fontSize: 10 }}>160</Typography>
      </Box>
    </Box>
  );
}
